<template>
  <section class="contacts-view">
    <div class="card contacts__wrap">
      <h3 class="contacts__title mb-0">
        {{ $t('contacts.contactsTitle') }}
      </h3>
      <hr>
      <div class="row">
        <div class="col-lg-12 col-sm-12">
          <UiInput
            v-model="subject"
            :label="$t('contacts.subject')"
            :placeholder="$t('contacts.title')"
            class="mb-8"
          />
          <UiTextarea
            v-model="message"
            v-model:error="errors.message"
            :label="$t('contacts.mesTitle')"
            :placeholder="$t('contacts.feedback')"
            :rows="5"
          />
        </div>
      </div>
      <hr class="mt-8">
      <div
        :class="{ loading: sending }"
        class="modal__footer-btn"
      >
        <button
          type="submit"
          class="btn btn-primary btn-sm modal__btn-confirm confirm mb-0 mt-0"
          @click="send"
        >
          <span>{{ $t('contacts.btnTitle') }}</span>
          <i
            v-if="sending"
            class="fas fa-spinner spinner-hide"
          />
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      subject: '',
      message: '',
      sending: false,
      errors: {},
    };
  },
  methods: {
    send() {
      this.sending = true;

      this.$api
        .sendMessage({ message: this.message })
        .then(() => {
          this.message = '';
          this.subject = '';

          this.$alert.success(this.$t('contacts.messageSend'));
          this.$eventBus.$emit('sendMessage');
          this.$router.push('/dashboard/profile');
        })
        .catch((err) => {
          this.errors = err.response.data.errors;
        })
        .finally(() => {
          this.sending = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import 'Contacts/styles/contacts';
</style>
